export const BOOK_VARIANTS = [
  { value: 'Amount', label: 'Amount only', to: false, from: false, body: false },
  { value: 'Message', label: 'Message only', to: false, from: false, body: true },
  { value: 'Receiver', label: 'Receiver only', to: true, from: false, body: false },
  { value: 'Sender', label: 'Sender only', to: false, from: true, body: false },
  { value: 'Receiver & Message', label: 'Receiver & Message', to: true, from: false, body: true },
  { value: 'Message & Sender', label: 'Message & Sender', to: false, from: true, body: true },
  { value: 'Receiver & Sender', label: 'Receiver & Sender', to: true, from: true, body: false },
];

export const QR_METHODS = [
  { value: 'zebra', label: 'Print with Zebra' },
  { value: 'pdf', label: 'Download PDF' },
];

export const LABEL_FIELDS = [
  { key: 'receiverName', label: 'Receiver name' },
  { key: 'senderName', label: 'Sender name' },
  { key: 'purchaseId', label: 'Purchase ID' },
  { key: 'amount', label: 'Amount' },
  { key: 'voucherId', label: 'Voucher ID' },
  { key: 'voucherNumber', label: 'Invoice number' },
];

export const MAX_LABEL_FIELDS = 2;

export const PRINT_OPTIONS_INITIAL_STATE = {
  bookEnabled: false,
  bookVariant: BOOK_VARIANTS[0].value,

  giftBoxEnabled: false,
  giftBoxVariant: BOOK_VARIANTS[0].value,

  qrEnabled: false,
  qrMethod: QR_METHODS[0].value,

  envelopeEnabled: false,
  envelopeFields: [],
  envelopeQuantity: 1,

  packageEnabled: false,
  packageFields: [],
  packageQuantity: 1,

  printing: false,
};

export const DELIVERY_BOOK_VARIANTS = [
  { value: 'SenderReceiver', label: 'With Sender & Receiver', to: true, from: true, body: true },
  { value: 'Sender', label: 'With Sender Only', to: false, from: true, body: true },
  { value: 'Receiver', label: 'With Receiver Only', to: true, from: false, body: true },
  { value: 'Message', label: 'Message Only', to: false, from: false, body: true },
  { value: 'Amount', label: 'Amount Only', to: false, from: false, body: false },
];

export const DELIVERY_INITIAL_STATE = {
  bookEnabled: false,
  bookVariant: DELIVERY_BOOK_VARIANTS[0].value,
  giftBoxEnabled: false,
  giftBoxVariant: DELIVERY_BOOK_VARIANTS[0].value,
  qrEnabled: false,
  qrMethod: QR_METHODS[0].value,
  labelsEnabled: false,
  labelFields: [],
  labelsQuantity: 1,
  packageEnabled: false,
  packageFields: [],
  packageQuantity: 1,
  printing: false,
};